// React Query hook for admin dashboard overview (ADM-011)
import { useQuery } from '@tanstack/react-query'
import { fetchAdminOverview } from '@/api/adminDashboard'

export const useAdminOverview = () => {
  return useQuery({
    queryKey: ['admin-overview'],
    queryFn: fetchAdminOverview,
    staleTime: 30_000, // 30s — dashboard data doesn't change often
  })
}
